import axios from "axios";
import { GET_PLANS_URL } from "../../../services/apis/plans/PlansUrl";
import { GET_PLANS } from "../../../services/types/PlansTypes";

export const getPlans = () => async (dispatch) => {
  try {
    const response = await axios.get(`${GET_PLANS_URL}`,{
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    });
    // console.log(response.data);
    if (response.data) {
      dispatch({
        type: GET_PLANS,
        payload: response.data,
      });
    }
  } catch (e) {}
};
